<template>
  <div
    :key="LKStore.project.id"
    class="charts-sections"
  >
    <section class="row-section">
      <div
        ref="refSentimentStatBar"
        class="half-panel"
      >
        <SentimentStatBar />
      </div>
      <div
        ref="refImportanceStatBar"
        class="half-panel"
      >
        <ImportanceStatBar />
      </div>
    </section>

    <section class="row-section">
      <div
        ref="refNewsDynamicChart"
        class="panel"
      >
        <NewsDynamicChart />
      </div>
    </section>

    <section class="row-section">
      <div
        ref="refCategoryDynamicChart"
        class="panel"
      >
        <CategoryDynamicChart />
      </div>
    </section>

    <section class="row-section">
      <div
        ref="refDomainBlocksStatBar"
        class="half-panel"
      >
        <DomainBlocksStatBar />
      </div>

      <div
        ref="refRegionStatBar"
        class="half-panel"
      >
        <RegionStatBar />
      </div>
    </section>
  </div>
</template>

<script setup>
import { ref, defineExpose } from "vue";
import { useLK } from "@/controllerLK/LKstore";
import { downloadChart } from "@/composables/usePdfExport";
import CategoryDynamicChart from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/CategoryDynamicChart.vue";
import NewsDynamicChart from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/NewsDynamicChart.vue";
import DomainBlocksStatBar from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/DomainBlocksStatBar.vue";
import RegionStatBar from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/RegionStatBar.vue";
import SentimentStatBar from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/SentimentStatBar.vue";
import ImportanceStatBar from "@/components/AnalyticsPage/AnalyticsGeneral/Charts/ImportanceStatBar.vue";

const LKStore = useLK();

// refs на все чарты
const refSentimentStatBar = ref(null);
const refImportanceStatBar = ref(null);
const refNewsDynamicChart = ref(null);
const refCategoryDynamicChart = ref(null);
const refDomainBlocksStatBar = ref(null);
const refRegionStatBar = ref(null);

// Массив чартов
const chartsArray = [
  refSentimentStatBar,
  refImportanceStatBar,
  refNewsDynamicChart,
  refCategoryDynamicChart,
  refDomainBlocksStatBar,
  refRegionStatBar
];

// Функция загрузки всех чартов в PDF
const handleDownload = async () => {
  await downloadChart(
    chartsArray,
    `Общая аналитика проекта «${LKStore.project.name}»`,
    "analytics-general"
  );
};

// Для доступа из родительского компонента AnalyticsPage
defineExpose({ handleDownload });
</script>

<style lang="scss" scoped>

.charts-sections {
  padding: 14px 0;

  .row-section {
    display: flex;
    gap: 20px;
    width: 100%;
    margin-bottom: 14px;

    .panel {
      width: 100%;
      border-radius: 10px;
    }

    .half-panel {
      width: 50% !important;
      border-radius: 10px;
    }
  }

}
</style>
